import { FC, useState } from 'react'

import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
  // ModalJustify
} from 'components'
// import useToggle from 'hooks/useToggle'
import { RequestCreateItemAnalise } from 'services/NGT/AnalyzeCRE'
import { TipoPendencia } from 'utils/types'

import { CollapsibleTable } from './components/CollapsibleTable'

export interface ITableAnalysisCre {
  tableData: RequestCreateItemAnalise[] | []
  listTipoDoc: TipoPendencia[] | undefined
  handleLiberado: (_data) => void
  handleQtdPendencias: (_data) => void
  handleDescricaoAnexo: (_data) => void
  handleObservacaoMovDocItem: (_data) => void
  novaAnalise?: boolean
  handleDeletePendency?: (_data: number | String, isIdItemCre: Boolean) => void
  isChecklist?: boolean
}
export const TableAnalysisCre: FC<ITableAnalysisCre> = ({
  tableData,
  listTipoDoc,
  novaAnalise,
  handleLiberado,
  handleQtdPendencias,
  handleDescricaoAnexo,
  handleObservacaoMovDocItem,
  handleDeletePendency,
  isChecklist
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)
  // const [showModal, toggleModal] = useToggle(false)

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>Recusar/Liberar</TableCellStyled>
              <TableCellStyled>Tipo Documento</TableCellStyled>
              <TableCellStyled>Observação</TableCellStyled>
              <TableCellStyled align="center">Qtd. Pend.</TableCellStyled>
              <TableCellStyled align="center" padding="checkbox">
                Justificativa
              </TableCellStyled>
              <TableCellStyled align="center">Valor Risco</TableCellStyled>
              <TableCellStyled align="center">Matrícula</TableCellStyled>
              <TableCellStyled align="center">Data Lib / Rec</TableCellStyled>
              <TableCellStyled align="center">Ações</TableCellStyled>
              <TableCellStyled align="center" />
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? tableData?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : tableData
            )?.map((row, index) => (
              <CollapsibleTable
                key={index}
                row={row}
                listTipoDoc={listTipoDoc}
                handleLiberado={handleLiberado}
                handleQtdPendencias={handleQtdPendencias}
                handleDescricaoAnexo={handleDescricaoAnexo}
                handleObservacaoMovDocItem={handleObservacaoMovDocItem}
                novaAnalise={novaAnalise}
                handleDeletePendency={handleDeletePendency}
                isChecklistAnalysis={isChecklist}
              />
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
      {/* <ModalJustify showModal={showModal} toggleModal={toggleModal} /> */}
    </>
  )
}
